module.exports = __webpack_public_path__ + "img/H5_guide.b0d3c1a1.jpg";